import React from "react";
import Modal from "../Modal";
import { PropTypes } from "prop-types";
import { connect } from "react-redux";
import { RiBuildingLine } from "react-icons/ri";
import { useState } from "react";
import CompteUniversite from "./CompteUniversite/CompteUniversite";
import Loader from "Components/Loader/loader";
import ModalAuthentificationEntreprise from "../ModalAuthentificationEntreprise/ModalAuthentificationEntreprise";
import { authenticateUser } from "Services/auth";

const ModalConnexion = (props) => {
  const API_LINK = process.env.REACT_APP_BASE_URL_API.split("/api")[0];
  const [visibleUniv, setVisibleUniv] = useState();
  const [chosenUniversity, setChosenUniversity] = useState(null);
  const [authEntrepriseVisible, setAuthEntrepriseVisible] = useState(false); // Si à true : on affiche le modal d'authentification entreprise

  const displayUniv = () => setVisibleUniv(true);
  return (
    <div>
      <Modal
        visible={props.visibleModal}
        setVisible={props.setVisibleModal}
        header="Créer un compte"
        blockScroll
      >
        <div className="modal_connection">
          <div className="modal_connection_left">
            <span>
              {" "}
              À quelle(s) université(s) souhaitez-vous être rattaché ?
            </span>
            <div className="modal_connection_university">
              {props.universities.universitiesData.length > 0 ? (
                props.universities.universitiesData.map((university, index) => (
                  <div
                    key={index}
                    className="modal_connection_university_button"
                    onClick={() => {
                      setChosenUniversity(university);
                      authenticateUser(university, true, displayUniv);
                    }}
                  >
                    <img
                      src={API_LINK + university.imageTransparentAndColorUrl}
                      alt="Logo_univ"
                    />
                  </div>
                ))
              ) : (
                <Loader></Loader>
              )}
            </div>
          </div>

          <div className="modal_connection_right">
            <div className="modal_connection_right_icon">
              <RiBuildingLine></RiBuildingLine>
            </div>

            <div className="modal_connection_right_message">
              <span>
                Cliquez ici, si vous êtes une entreprise ou un recruteur
              </span>
            </div>

            <button
              className="modal_connection_right_button"
              onClick={() => {
                setAuthEntrepriseVisible(true);
              }}
            >
              Je suis une entreprise
            </button>
          </div>
        </div>
      </Modal>

      {visibleUniv && chosenUniversity && (
        <Modal
          visible={visibleUniv}
          setVisible={setVisibleUniv}
          header="Formulaire université"
          blockScroll
        >
          <CompteUniversite
            setVisibleUniv={setVisibleUniv}
            setVisibleModalGlobal={props.setVisibleModal}
            chosenUniversity={chosenUniversity}
            setChosenUniversity={setChosenUniversity}
          ></CompteUniversite>
        </Modal>
      )}

      {authEntrepriseVisible && (
        <ModalAuthentificationEntreprise
          authEntrepriseVisible={authEntrepriseVisible}
          setAuthEntrepriseVisible={setAuthEntrepriseVisible}
          authState="register"
        />
      )}
    </div>
  );
};

ModalConnexion.propTypes = {
  universities: PropTypes.object,

  visibleModal: PropTypes.bool,
  setVisibleModal: PropTypes.func,
};

const mapStateToProps = (state) => ({
  universities: state.universities,
});

const mapDispatchToProps = () => ({});
export default connect(mapStateToProps, mapDispatchToProps)(ModalConnexion);
